export default "__VITE_ASSET__CNbFT$FK__"